import { createSlice } from '@reduxjs/toolkit';
import { ERROR_MESSAGES } from '../../constants/server/error';

const SILENT_ERRORS = ['Bad Request'];

const initialState = {
  loadingCount: 0,
  error: null
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    startLoading: state => {
      state.loadingCount += 1;
    },
    stopLoading: state => {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
    },
    setError: (state, action) => {
      const errorMessage = ERROR_MESSAGES[action.payload] || action.payload;
      state.error = errorMessage;
      if (errorMessage && !SILENT_ERRORS.includes(action.payload)) {
        alert(errorMessage);
        state.error = null;
      }
    },
    clearError: state => {
      state.error = null;
    },
    resetLoadingState: () => initialState
  }
});

export const { startLoading, stopLoading, setError, clearError, resetLoadingState } = commonSlice.actions;
export default commonSlice.reducer;
